import React, { Component } from "react";
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import { Route, Switch, Redirect } from "react-router-dom";
import NotificationSystem from "react-notification-system";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Sidebar from "../../components/Sidebar/Sidebar";

import { style } from "../../variables/Variables.jsx";

import {getSchedule, getCompletedSchedule, getAvailability} from "../../actions/scheduleActions";

import dashboardRoutes from "../../routes/dashboard.jsx";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleNotificationClick = this.handleNotificationClick.bind(this);
    this.state = {
      _notificationSystem: null
    };
  }
  handleNotificationClick() {
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    const scheduleParams = {
      installer_id:this.props.auth.installer ? this.props.auth.installer.id : "",
      limit:30,
      page:1,
      session:localStorage.getItem('sessionToken'),
      sort_field:'appointment_date',
      type:'future'
    }
    const completedParams = {
      installer_id: this.props.auth.installer ? this.props.auth.installer.id : "",
      limit:30,
      page:1,
      session:localStorage.getItem('sessionToken'),
      sort_field:'appointment_date',
      type:'past'
    }
    const availabilityParams = {
      installer_id: this.props.auth.installer ? this.props.auth.installer.id : "",
      session: localStorage.getItem('sessionToken')
    }

    this.props.getSchedule(scheduleParams);
    this.props.getCompletedSchedule(completedParams);
    this.props.getAvailability(availabilityParams);
  }
  componentDidUpdate(e) {
    if (
      window.innerWidth < 993 &&
      e.history.location.pathname !== e.location.pathname &&
      document.documentElement.className.indexOf("nav-open") !== -1
    ) {
      document.documentElement.classList.toggle("nav-open");
    }
    if (e.history.action === "PUSH") {
      document.documentElement.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
      this.refs.mainPanel.scrollTop = 0;
    }
  }
  render() {
    return (
      <div className="wrapper">
        <NotificationSystem ref="notificationSystem" style={style} />
        <Sidebar {...this.props} />
        <div id="main-panel" className="main-panel" ref="mainPanel">
          <Header {...this.props} />
          <Switch>
            {dashboardRoutes.map((prop, key) => {
              if (prop.name === "Notifications")
                return (
                  <Route
                    path={prop.path}
                    key={key}
                    render={routeProps => (
                      <prop.component
                        {...routeProps}
                        handleClick={this.handleNotificationClick}
                      />
                    )}
                  />
                );
              if (prop.redirect)
                return <Redirect from={prop.path} to={prop.to} key={key} />;
              return (
                <Route path={prop.path} component={prop.component} key={key} />
              );
            })}
          </Switch>
          <Footer />
        </div>
      </div>
    );
  }
}

Dashboard.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  schedule: PropTypes.object.isRequired,
  getSchedule: PropTypes.func.isRequired,
  getCompletedSchedule: PropTypes.func.isRequired,
  getAvailability: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors,
  schedule: state.schedule,
  availability: state.availability
});

export default connect(mapStateToProps, {getSchedule, getCompletedSchedule, getAvailability})(Dashboard);



// WEBPACK FOOTER //
// ./src/layouts/Dashboard/Dashboard.jsx